export const DELAY_BEFORE_REMOVE_MSEC = 350;
